<template>
  <div class="user-manual-wrap">
    <h3>請掃描指紋以更新登入用指紋</h3>
  </div>
</template>

<script>
export default {
  name: 'Barcode',
  components: {
  },
  mounted() {
    this.$store.dispatch('sendScanFingerCommand');
  },
  methods: {
    saveFingerprint(feature) {
      this.instance.patch(`/api/user/${this.user.id}/`, {
        fingerprint: feature,
      })
      .then((res) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });
        this.$router.push({ name: 'userManual' });
      })
      .catch(() => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '更新失敗',
        });
      });
    },
  },
  computed: {
    fingerprint() {
      return this.$store.state.user.fingerprint;
    },
    user() {
      return this.$store.state.user.user;
    },
    instance() {
      return this.$store.state.instance;
    },
  },
  watch: {
    fingerprint(val) {
      this.saveFingerprint(val);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Fingerprint.vue?235d0c91